import { BadgeConfig } from '@w3lcome/types';
import { badgeScale } from '_/constants/badgeScale';

export const paper29mmx90mmTest: BadgeConfig = {
  width: 900 * badgeScale,
  height: 290 * badgeScale,
  isTest: true,
  fields: [
    {
      type: 'text',
      subType: 'text',
      value: 'Printer working',
      styles: {
        top: 80 * badgeScale,
        left: 100 * badgeScale,
        width: 900 * badgeScale,
        height: 120 * badgeScale,
        fontSize: 100 * badgeScale,
        fontWeight: 'bold',
      },
    },
  ],
};
